export const REQUEST_PROFILE_TAB_INTERNAL_TASKS_TEMPLATE_SELECT_PAGE_SIZE = 10

export const REQUEST_PROFILE_TAB_INTERNAL_TASKS_TEMPLATE_SELECT_API_PARAMS = {
  page_size: REQUEST_PROFILE_TAB_INTERNAL_TASKS_TEMPLATE_SELECT_PAGE_SIZE,
}
